import { numPattern } from '../constants/patterns';

export const phoneMask = (phone) => {
  return phone
    .replace(numPattern, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{3})(\d{1,3})/, '$1) $2')
    .replace(/(\s\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};
